import { Injectable } from '@angular/core'
import { AttributesService, FeedbackService, SearchFeedbackRequestDTO } from '../../../apiModule'
import { sanitizeFullAttributes } from '../../../core/attributes-utils'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'

@Injectable({ providedIn: 'root' })
export class FeedbackArchiveApiService {
  constructor(
    private attributeService: AttributesService,
    private feedbackService: FeedbackService
  ) {}

  searchFeedbacks(
    searchRequest: SearchFeedbackRequestDTO
  ): Observable<any> {
    return this.feedbackService.searchFeedback(searchRequest)
  }

  getFullAttributes(): Observable<any> {
    return this.attributeService.get().pipe(map(sanitizeFullAttributes))
  }
}
